import { render, staticRenderFns } from "./partnersName.vue?vue&type=template&id=6738a5a4&scoped=true"
import script from "./partnersName.vue?vue&type=script&lang=js"
export * from "./partnersName.vue?vue&type=script&lang=js"
import style0 from "./partnersName.vue?vue&type=style&index=0&id=6738a5a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6738a5a4",
  null
  
)

export default component.exports